import React from "react";
import classes from "./Hero.module.css";
import hero from "../assests/images/hero.jpg";
import ButtonLink from "../utils/ButtonLink";
export default function Hero() {
  return (
    <div className={classes.hero}>
      <div className={classes.heroImageBox}>
        <div className={classes.content}>
          <div>
            <h1>Order daily from 6 p.m. to 5 a.m</h1>
            <p>It's never too late for us</p>
          </div>
          <ButtonLink to="/all-products" style={{ fontSize: "1.8rem" }}>
            Shop Now
          </ButtonLink>
        </div>

        <div className={classes.heroImageContainer}>
          <img alt="hero" className={classes.heroImage} src={hero} />
        </div>
      </div>
    </div>
  );
}
